export enum MediaOrder {
    BEFORE = 'before',
    AFTER = 'after'
}
